<template>
    <SearchTitle data-testid="europa-fallback-search-title">
        {{ resultCountTitle }}
    </SearchTitle>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import SearchTitle from './SearchTitle.vue';
    import {useProfilesStore} from '../../stores/profiles.store';
    import {useSearchUrlStore} from '../../stores/search-url.store';

    const {t} = useTranslation();

    const {europaFallbackSearchResponse} = storeToRefs(useProfilesStore());
    const searchUrlStore = useSearchUrlStore();
    const {searchUrlParams} = storeToRefs(searchUrlStore);

    const MAX_NB_RESULTS = 300;

    const resultCountTitle = computed(() =>
        t('search.header.icu.title.host.countries', {
            cappedNbResults: Math.min(europaFallbackSearchResponse.value?.pagination.totalElements ?? 0, MAX_NB_RESULTS),
            jobLabel: searchUrlParams.value.query,
        }),
    );
</script>
